import { render, staticRenderFns } from "./NoticePage.vue?vue&type=template&id=51c2c7c4&"
import script from "./NoticePage.vue?vue&type=script&lang=js&"
export * from "./NoticePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports